/* Cart drawer — Simply Carbon Fiber (2026-09-15). Keeps the one-line subtotal ("NN% SAVED", struck original),
   the "Checkout+ · total" button and the priority ? prompt in step with theme.js's AJAX cart updates. */
(function () {
  'use strict';
  function cents(el) { if (!el) return 0; var d = (el.textContent || '').replace(/[^0-9]/g, ''); return d ? parseInt(d, 10) : 0; }
  function num(el) { var c = el && el.querySelector('[data-cents]'); return c ? (parseInt(c.getAttribute('data-cents'), 10) || 0) : cents(el); }
  function money(c) { var m = (window.theme && theme.Currency) ? theme.Currency.formatMoney(c, theme.settings.moneyFormat) : ('$' + (c / 100).toFixed(2)); return String(m).replace(/<[^>]+>/g, '').trim(); }   /* formatMoney wraps in <span class="money">; we only want the text */
  /* write only when a value actually changes: the observer below watches the same footer, so unconditional
     writes would re-trigger it forever */
  function put(el, text, show) {
    if (!el) return;
    if (el.textContent !== text) el.textContent = text;
    if (el.hidden !== !show) el.hidden = !show;
  }
  var busy = false;
  function sync(drawer) {
    if (busy) return; busy = true;
    try {
      var tot = drawer.querySelector('[data-scf-tot]'); if (!tot) return;
      /* SCF 2026-10-07 (audit, Sergio approved): read Shopify's own numbers, not the formatted text. Reading "¥8,500" as cents
         showed CHECKOUT+ ¥1,285 for ¥9,700 in yen and other no-decimal currencies. theme.js puts the fresh subtotal on
         .cart__items[data-cart-subtotal] after every update; the first render carries data-cents. Text stays the fallback. */
      var items = drawer.querySelector('[data-cart-subtotal]');
      var sub = items ? (parseInt(items.getAttribute('data-cart-subtotal'), 10) || 0) : num(drawer.querySelector('[data-subtotal]'));
      var sav = num(drawer.querySelector('[data-cart-savings]'));
      var orig = sub + sav;
      var label = (tot.dataset.pillLabel || '[pct]% Off').replace('[pct]', String(Math.round(sav * 100 / (orig || 1) / 5) * 5));
      put(tot.querySelector('[data-scf-saved-pct]'), (sav > 0 && orig > 0) ? label : '', sav > 0 && orig > 0);
      put(tot.querySelector('[data-scf-orig]'), sav > 0 ? money(orig) : '', sav > 0);
      var co = drawer.querySelector('[data-scf-co-total]');
      /* SCF 2026-10-26 ("go gift card"): nothing ships (gift cards only) = no Priority row, no "+", no fee in the total */
      var ships = !items || items.getAttribute('data-cart-ships') !== 'false';
      if (drawer.classList.contains('scf-noship') === ships) drawer.classList.toggle('scf-noship', !ships);
      if (co) { var addon = ships ? parseInt(tot.dataset.addonPrice || '0', 10) : 0; var txt = sub > 0 ? ' · ' + money(sub + addon) : ''; if (co.textContent !== txt) co.textContent = txt; }
    } finally { busy = false; }
  }
  function init(drawer) {
    if (drawer.__scfCart) return; drawer.__scfCart = true;
    sync(drawer);
    var footer = drawer.querySelector('.drawer__footer') || drawer;
    var pending = null;
    new MutationObserver(function () { if (pending) return; pending = setTimeout(function () { pending = null; sync(drawer); }, 50); }).observe(footer, { childList: true, subtree: true, characterData: true });
    /* ? prompt */
    var q = drawer.querySelector('[data-scf-q]'), pop = drawer.querySelector('[data-scf-pop]');
    if (q && pop) {
      var open = function (on) { pop.hidden = !on; q.setAttribute('aria-expanded', on ? 'true' : 'false'); };
      q.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); open(pop.hidden); });
      var x = pop.querySelector('[data-scf-pop-close]'); if (x) x.addEventListener('click', function (e) { e.preventDefault(); open(false); });
      document.addEventListener('click', function (e) { if (!pop.hidden && !pop.contains(e.target) && e.target !== q) open(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') open(false); });
    }
  }
  /* ---- Bundle & Save rows: same matching as the product-page add-ons ---- */
  function rowsOf(el) {
    return (el.dataset.variants || '').split(';').filter(Boolean).map(function (r) {
      var p = r.split('|');
      return { id: p[0], title: p[1] || '', price: parseInt(p[2] || '0', 10), img: p[3] || '', compare: parseInt(p[4] || '0', 10), parts: (p[1] || '').split(' / ').map(function (x) { return x.trim().toLowerCase(); }) };
    });
  }
  function syncUpsell(row) {
    var rows = rowsOf(row); if (!rows.length) { row.hidden = true; return; }
    var device = (row.dataset.device || '').trim().toLowerCase();
    var hasDev = row.dataset.deviceOption === 'true';
    var pickers = Array.prototype.slice.call(row.querySelectorAll('[data-scf-dots]'));
    var picked = pickers.map(function (p) { var on = p.querySelector('[data-value].is-active'); return on ? { position: parseInt(p.dataset.option, 10) - 1, value: on.dataset.value.toLowerCase() } : null; }).filter(Boolean);
    var devicePosition = parseInt(row.dataset.devicePosition || '0', 10);
    var devOk = function (r) { return !device || !hasDev || (devicePosition ? r.parts[devicePosition - 1] === device : r.parts.indexOf(device) !== -1); };
    var match = null;
    for (var i = 0; i < rows.length && !match; i++) { if (devOk(rows[i]) && picked.every(function (v) { return rows[i].parts[v.position] === v.value; })) match = rows[i]; }
    for (var j = 0; j < rows.length && !match; j++) { if (devOk(rows[j])) match = rows[j]; }
    if (!match) { row.hidden = true; return; }
    row.hidden = row.dataset.purchased === 'true';
    var btn = row.querySelector('.rec-add'); if (btn) btn.dataset.id = match.id;
    var img = row.querySelector('.scf-cu__img'); if (img && match.img && img.getAttribute('src') !== match.img) img.src = match.img;
    var pr = row.querySelector('[data-scf-cu-price]');
    if (pr) { var html = '<b>' + money(match.price) + '</b>' + (match.compare > match.price ? '<s>' + money(match.compare) + '</s>' : ''); if (pr.innerHTML !== html) pr.innerHTML = html; }
    pickers.forEach(function (p) {
      var awaitingChoice = p.hasAttribute('data-requires-choice') && !p.dataset.chosen;
      p.querySelectorAll('[data-value]').forEach(function (d) {
        var v = d.dataset.value.toLowerCase(), position = parseInt(p.dataset.option, 10) - 1;
        var made = rows.some(function (r) { return r.parts[position] === v && devOk(r) && picked.every(function (other) { return other.position === position || r.parts[other.position] === other.value; }); });
        d.classList.toggle('is-off', !made); d.disabled = !made;
        d.setAttribute('aria-disabled', made ? 'false' : 'true');
        d.classList.toggle('is-active', !awaitingChoice && match.parts[position] === v);
        if (p.dataset.mode === 'dots') d.setAttribute('aria-pressed', d.classList.contains('is-active') ? 'true' : 'false');
        if (d.getAttribute('role') === 'radio') d.setAttribute('aria-checked', d.classList.contains('is-active') ? 'true' : 'false');
      });
      var name = p.querySelector('[data-scf-dot-name]') || (p.nextElementSibling && p.nextElementSibling.hasAttribute('data-scf-dot-name') ? p.nextElementSibling : null), on = p.querySelector('[data-value].is-active');
      var caption = awaitingChoice ? (p.dataset.placeholder || 'Select a device') : (on ? on.dataset.value : '');
      if (name && name.textContent !== caption) name.textContent = caption;
    });
    var go = row.querySelector('[data-scf-cu-go]');
    if (go) {
      row.classList.add('scf-cu--choose');
      var awaiting = pickers.find(function (p) { return p.hasAttribute('data-requires-choice') && !p.dataset.chosen; });
      if (!go.dataset.label) go.dataset.label = go.textContent.trim();
      go.disabled = !!row.__scfAdding || !!awaiting;
      var goText = awaiting ? (awaiting.dataset.placeholder || 'Select a device') : go.dataset.label + ' · ' + money(match.price);
      if (go.textContent !== goText) go.textContent = goText;
    }
  }
  function arrangeOffers(box) {
    var host = box.querySelector('[data-scf-offers]') || box;
    var groups = Object.create(null);
    host.querySelectorAll('[data-scf-offer-group]').forEach(function (group) { groups[group.dataset.scfOfferGroup] = group; });
    host.querySelectorAll('[data-scf-cu]').forEach(function (row) {
      var key = row.dataset.offerGroup || 'general', group = groups[key];
      if (!group) {
        group = document.createElement('section'); group.className = 'scf-offer-group'; group.dataset.scfOfferGroup = key;
        var heading = document.createElement('h5'); heading.className = 'scf-offer-group__heading';
        heading.textContent = key === 'general' ? (host.dataset.otherLabel || 'Other add-ons') : (row.dataset.offerLabel || 'For ' + row.dataset.device);
        group.setAttribute('aria-label', heading.textContent); group.appendChild(heading);
        var list = document.createElement('div'); list.className = 'scf-offer-group__rows'; group.appendChild(list);
        host.insertBefore(group, key !== 'general' && groups.general ? groups.general : null); groups[key] = group;
      }
      var list = group.querySelector('.scf-offer-group__rows'); if (row.parentNode !== list) list.appendChild(row);
    });
    Object.keys(groups).forEach(function (key) {
      var group = groups[key]; group.hidden = !Array.prototype.some.call(group.querySelectorAll('[data-scf-cu]'), function (row) { return !row.hidden; });
    });
  }
  function offerStatus(box, text, error) {
    var status = box.querySelector('[data-scf-offer-status]');
    if (!status) { status = document.createElement('div'); status.className = 'scf-offer-status'; status.dataset.scfOfferStatus = ''; status.setAttribute('role', 'status'); box.appendChild(status); }
    status.textContent = text; status.classList.toggle('is-error', !!error);
  }
  function initUpsells(drawer) {
    var box = drawer.querySelector('.upsell-box-wrapper'); if (!box) return;
    var heads = box.querySelectorAll('h4'); for (var h = 1; h < heads.length; h++) heads[h].remove();
    box.querySelectorAll('[data-scf-cu]').forEach(function (row) {
      if (row.__scfCu) return; row.__scfCu = true;
      row.querySelectorAll('[data-scf-dots] [data-value]').forEach(function (d) {
        d.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          if (row.__scfAdding || row.dataset.purchased === 'true') return;
          if (d.classList.contains('is-off')) return;
          d.closest('[data-scf-dots]').dataset.chosen = 'true';
          d.closest('[data-scf-dots]').querySelectorAll('[data-value]').forEach(function (x) { x.classList.remove('is-active'); });
          d.classList.add('is-active'); syncUpsell(row);
        });
      });
      var ck = row.querySelector('[data-scf-cu-ck]'), add = row.querySelector('.scf-cu__add'), go = row.querySelector('[data-scf-cu-go]');
      var fire = function () {
        if (row.__scfAdding || row.dataset.purchased === 'true' || row.hidden || !add || !add.dataset.id || (go && go.disabled)) return;
        row.__scfAdding = true; row.classList.add('is-adding'); row.setAttribute('aria-busy', 'true');
        if (ck) ck.disabled = true; if (go) go.disabled = true;
        var host = box.querySelector('[data-scf-offers]') || box;
        var body = { id: parseInt(add.dataset.id, 10), quantity: 1 };
        if (row.dataset.parent) body.properties = { _scf_parent: String(row.dataset.parent), _scf_kit: 'addon' };
        if (body.properties && row.dataset.parentGroup) body.properties._scf_parent_group = row.dataset.parentGroup;
        else if (body.properties && row.dataset.parentVariant) body.properties._scf_parent_variant = row.dataset.parentVariant;
        var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var accepted = false, markup = '';
        body.sections = 'cart-ajax-section';   /* SCF 2026-09-22: the drawer markup comes back with the add (theme.js uses it, no /cart?view=ajax fetch) */
        fetch(cartRoot + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            accepted = true; row.dataset.purchased = 'true'; row.hidden = true; arrangeOffers(box);
            offerStatus(box, host.dataset.addedLabel || 'Added to your cart.', false);
            return r.json().catch(function () { return null; });
          })
          .then(function (added) {
            if (added && added.sections && added.sections['cart-ajax-section']) markup = added.sections['cart-ajax-section'];
            document.dispatchEvent(new CustomEvent('cart:build', { detail: { markup: markup } }));
          })
          .catch(function () {
            if (accepted) { document.dispatchEvent(new CustomEvent('cart:build')); return; }
            if (ck) ck.checked = false;
            offerStatus(box, host.dataset.errorLabel || 'This item could not be added. Please try again.', true);
          })
          .finally(function () { row.__scfAdding = false; row.classList.remove('is-adding'); row.removeAttribute('aria-busy'); if (ck) ck.disabled = false; if (go) go.disabled = false; });
      };
      if (ck && add) ck.addEventListener('change', function () { if (ck.checked && !go) fire(); });
      if (go && add) go.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); fire(); });
      syncUpsell(row);
    });
    arrangeOffers(box);
  }
  /* the plain /cart page has none of the gift or priority logic: hand it to the drawer (2026-09-20) */
  function cartPageHandoff() {
    if (!document.body.classList.contains('template-cart')) return;
    var openDrawer = function () {
      /* theme.js deliberately skips the drawer on the cart page; start it here so the page uses the same cart as everywhere else */
      if (!window.__scfCartDrawer && window.theme && theme.CartDrawer && theme.settings && theme.settings.cartType === 'drawer') { try { window.__scfCartDrawer = new theme.CartDrawer(); } catch (e) {} }
      document.dispatchEvent(new CustomEvent('cart:open'));
    };
    setTimeout(openDrawer, 500);
    var pf = document.getElementById('CartPageForm');
    if (pf) pf.addEventListener('submit', function (e) { if (e.submitter && e.submitter.name === 'checkout') { e.preventDefault(); e.stopImmediatePropagation(); openDrawer(); } }, true);
  }
  function boot() { cartPageHandoff(); var d = document.getElementById('CartDrawer'); if (d) { init(d); initUpsells(d); var up = d.querySelector('.drawer__upper'); if (up && !up.__scfObs) { up.__scfObs = true; var t = null; new MutationObserver(function () { if (t) return; t = setTimeout(function () { t = null; initUpsells(d); }, 60); }).observe(up, { childList: true, subtree: true }); } } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* iOS Safari paints the status-bar strip with <meta name="theme-color">. While a drawer is open, match it to the drawer's
   background so the drawer reads as full screen (Ridge-style); restore the site colour on close. */
(function () {
  'use strict';
  var meta = document.querySelector('meta[name="theme-color"]');
  if (!meta) { meta = document.createElement('meta'); meta.setAttribute('name', 'theme-color'); document.head.appendChild(meta); }
  var site = meta.getAttribute('content') || '';
  var drawerBg = (getComputedStyle(document.documentElement).getPropertyValue('--colorDrawers') || '#ffffff').trim() || '#ffffff';
  var apply = function () {
    var open = document.documentElement.classList.contains('js-drawer-open');
    var want = open ? drawerBg : site;
    if (meta.getAttribute('content') !== want) meta.setAttribute('content', want);
  };
  new MutationObserver(apply).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  apply();
})();
